import { render, staticRenderFns } from "./controlGroupXXL.vue?vue&type=template&id=7f63aa98&lang=true&"
import script from "./controlGroupXXL.vue?vue&type=script&lang=js&"
export * from "./controlGroupXXL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports